<template>
    <div>

        <b-card>
            <b-card-body>
                <h4 class="mb-4">Edit Session</h4>

                <b-form-row>
                    <b-col cols="6">
                        <label>Session Title <span class="required">*</span></label>
                        <b-form-input v-model="session.title"></b-form-input>
                    </b-col>

                    <b-col>
                        <label>Session/Slot <span class="required">*</span></label>
                        <b-form-input v-model="session.slot" placeholder="ie. Keynote, Breakout 1"></b-form-input>
                    </b-col>
                    <b-col>
                        <label>Presenter <span class="required">*</span></label>
                        <b-form-input v-model="session.presenter"></b-form-input>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-3">
                    <b-col cols="8">
                        <label>Online Presentation/Meeting Link (if applicable)</label>
                        <b-form-input v-model="session.online_mtg_link"></b-form-input>
                    </b-col>
                    <b-col>
                        <label>Access Button Label</label>
                        <b-form-input v-model="session.online_mtg_button"></b-form-input>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-3">
                    <b-col>
                        <label>Online Materials Link (if applicable)</label>
                        <b-form-input v-model="session.online_materials_link"></b-form-input>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-3">
                    <b-col>
                        <b-form-group>
                            <label>Start Date <span class="required">*</span></label>
                            <b-form-datepicker id="datepicker-placeholder" local="en" v-model="session.start_at"></b-form-datepicker>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group>
                            <label>Start Time <span class="required">*</span></label>
                            <b-form-timepicker v-model="session.start_time" locale="en"></b-form-timepicker>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group>
                            <label>End Date <span class="required">*</span></label>
                            <b-form-datepicker id="datepicker-placeholder2" local="en" v-model="session.end_at"></b-form-datepicker>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group>
                            <label>End Time <span class="required">*</span></label>
                            <b-form-timepicker v-model="session.end_time" locale="en"></b-form-timepicker>
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-3">
                    <b-col>
                        <label>Description <span class="required">*</span></label>

                        <quill-editor v-model="session.description" ref="myQuillEditor" :options="editorOption">
                        </quill-editor>
                    </b-col>
                </b-form-row>
                <b-form-row class="mt-3">
                    <b-col>
                        <label>Information <span class="required">*</span></label>

                        <quill-editor v-model="session.information" ref="myQuillEditor" :options="editorOption">
                        </quill-editor>
                    </b-col>
                </b-form-row>
                <b-row>
                    <b-col>
                        <b-button variant="success" class="mt-5" @click="updateSess()"><i class="far fa-check mr-3"></i>Save Session</b-button>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <b-card class="mt-4">
            <b-card-body>
                <h4 class="mb-4">Session Materials/Handouts</h4>

                <b-form-row class="mt-4">
                    <b-col>
                        <material-row :session="session" :material="material" v-for="material in session.materials"></material-row>
                    </b-col>
                </b-form-row>
                <b-form-row class="mt-4">
                    <b-col>
                        <file-pond
                                name="file"
                                ref="pond"
                                label-idle="Drop or click to add files..."
                                :allow-multiple="true"
                                :allowRevert="false"
                                accepted-file-types="image/jpeg, image/png, image/gif, text/plain, audio/mpeg, video/mpeg, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation"
                                :files="myFiles"
                                @init="handleFilePondInit"
                                @processfile="handleFilePondProcess"
                                :server="{
                                    url: apiUrl,
                                    timeout: 7000,
                                    process: {
                                        url: 'api/session/' + sessId + '/material',
                                        method: 'POST',
                                        headers: {
                                            'Authorization': token
                                        },
                                        withCredentials: false
                                    }
                                }"
                        />
                    </b-col>
                </b-form-row>
            </b-card-body>
        </b-card>


    </div>

</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {apiUrl} from '@/constants/config';
    import moment from 'moment';

    // Import Vue FilePond
    import vueFilePond from 'vue-filepond';

    // Import FilePond styles
    import 'filepond/dist/filepond.min.css';

    // Import FilePond plugins
    // Please note that you need to install these plugins separately

    // Import image preview plugin styles
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

    // Import image preview and file type validation plugins
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
    import MaterialRow from "../../../../components/MaterialRow";

    // Create component
    const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);


    export default {
        name: "sess-edit",
        components: {MaterialRow, FilePond},
        props: ['sessId', 'id'],
        data: function () {
            return {
                session: {
                    conference: {},
                    fee: {}
                },
                editorOption: {
                    // some quill options
                },
                content: '',
                apiUrl: apiUrl,
                myFiles: []
            };
        },
        methods: {
            ...mapActions(['getSessionById', 'updateSession']),

            updateSess() {
                let startAt = new Date(this.session.start_at + ' ' + this.session.start_time);
                let endAt = new Date(this.session.end_at + ' ' + this.session.end_time);

                // console.log(this.session.start_at, this.session.start_time);

                let payload = {
                    title: this.session.title,
                    slot: this.session.slot,
                    presenter: this.session.presenter,
                    start_at: startAt.toISOString(),
                    end_at: endAt.toISOString(),
                    description: this.session.description,
                    information: this.session.information,
                    online_mtg_link: this.session.online_mtg_link,
                    online_mtg_button: this.session.online_mtg_button,
                    online_materials_link: this.session.online_materials_link
                };

                this.updateSession({id: this.sessId, data: payload}).then(() => {
                    this.$notify('success', 'Update Session', 'Session has been saved.', {duration: 5000, permanent: false});
                    this.$router.push('/org/conference/' + this.id + '/sessions');
                });
            },

            handleFilePondInit: function () {
                console.log('FilePond has initialized');
                // FilePond instance methods are available on `this.$refs.pond`
            },

            handleFilePondProcess: function (err, file) {
                // Todo this doesn't handle errors
                // FilePond:processfile - Finished processing a file, if the detail object contains an error property, something went wrong
                this.session.materials.push(JSON.parse(file.serverId));
                setTimeout(function () {
                    this.$refs.pond.removeFile(file.id);
                }.bind(this), 3000);

            },

            editMaterial: function (material) {

            }
        },
        computed: {
            ...mapGetters(['token'])
        },
        mounted: function () {
            this.getSessionById(this.sessId).then(response => {

                let startDate = new Date(response.start_at);
                let endDate = new Date(response.end_at);

                this.session = response;

                this.session.start_at = moment(startDate).format('YYYY-MM-DD');
                this.session.start_time = moment(startDate).format('HH:mm:ss');
                this.session.end_at = moment(endDate).format('YYYY-MM-DD');
                this.session.end_time = moment(endDate).format('HH:mm:ss');

                // console.log(typeof response.start_at, response.start_at);
                // console.log(this.session.start_at);
                // console.log(this.session.end_at);
                // console.log(this.session.start_time);
                // console.log(this.session.end_time);


                //                let startDate = new Date(response.start_at);

                // this.session.start_time = ('0'+startDate.getHours()).substr(-2) + ':' + ('0'+startDate.getMinutes()).substr(-2) + ':00';
                //
                // let endDate = new Date(response.end_at);
                // this.session.end_time = ('0'+endDate.getHours()).substr(-2) + ':' + ('0'+endDate.getMinutes()).substr(-2) + ':00';
                //
                // console.log(this.session);
            });
        }
    };
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

</style>
